export class RequestPreviewDto {
  startDate: string;
  endDate: string;
  allEmp: number;
  listEmp: any[];
}

export class RequestDownloadExcelDto {
  startDate: string;
  endDate: string;
  allEmp: number;
  listEmp: any[];
}

export class RequestDownloadPdfDto {
  startDate: string;
  endDate: string;
  allEmp: number;
  listEmp: any[];
}

export class RequestReportSendEmailExcelDto {
  startDate: string;
  endDate: string;
  allEmp: number;
  listEmp: any[];
  email: string;
  fullName: string;
}


export class RequestReportSendEmailPdfDto {
  startDate: string;
  endDate: string;
  allEmp: number;
  listEmp: any[];
  email: string;
  fullName: string;
}

export class ResponseReportSendEmailExcelDto {
  message: string;
  data?: any;
}

export class ResponseReportSendEmailPdfDto {
  message: string;
  data?: any;
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/dto/emp-ovt-report.dto.ts